import { ButtonSet, Form, Loading } from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CancelButton from "../../components/Buttons/CancelButton";
import SubmitButton from "../../components/Buttons/SubmitButton";
import http from "../../http-common";
import Card from "../../components/Card/Card";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Tabs } from "carbon-components-react";
import { Tab } from "carbon-components-react";
import { Button } from "carbon-components-react";
import { ArrowRight20 } from "@carbon/icons-react";
import { ArrowLeft20 } from "@carbon/icons-react";
import useCandidature from "../../hooks/useCandidature";
import { yupResolver } from "@hookform/resolvers/yup";
import { basicCandidatureSchema } from "../../services/SchemaService";
import ApplicationDisclaimer from "../../components/Miscellaneous/ApplicationDisclaimer";
import DocumentForm from "../../components/Forms/DocumentForm";
import TeamForm from "../../components/Forms/TeamForm";
import ProjectDetailsForm from "../../components/Forms/ProjectDetailsForm";
import CompanyDetailsForm from "../../components/Forms/CompanyDetailsForm";

const UpdateCandidaturePage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { isLoading, candidature } = useCandidature(uuid);
  const [activeTab, setActiveTab] = useState(0);
  const [isOpen, setIsOpen] = useState(true);
  const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(basicCandidatureSchema),
    mode: "onBlur",
  });

  const onSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const submissionData = {
        ...data,
        documents: documents,
        teamMembers: teamMembers,
        uuid: uuid,
      };
      const response = await http.put("/applications", submissionData);
      toast.success("Candidatura Actualizada com sucesso");
      navigate("../candidature/" + response.data);
    } catch (error) {
      toast.error(error?.response?.data.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    reset(candidature);
    setIsOpen(candidature.currentStatusCode === 1);
  }, [candidature]);

  const nextTab = () => {
    setActiveTab((prev) => prev + 1);
  };
  const previousTab = () => {
    setActiveTab((prev) => prev - 1);
  };

  return (
    <Card title="Editar Candidatura">
      <Loading
        active={isLoading || isSubmitting}
        description="Active loading indicator"
        withOverlay={true}
      />
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Tabs
          scrollIntoView={false}
          selected={activeTab}
          type={"container"}
          onSelectionChange={(e) => setActiveTab(e)}
        >
          <Tab href="#" id="tab-0" label="Declaração">
            <ApplicationDisclaimer />
            <div className="tab-navigation">
              <p></p>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-0" label="Dados da Empresa">
            <CompanyDetailsForm
              reset={reset}
              register={register}
              control={control}
              errors={errors}
              candidature={candidature}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-3" label="Dados do Projecto">
            <ProjectDetailsForm
              candidature={candidature}
              register={register}
              control={control}
              errors={errors}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-3" label="Equipa do Projecto">
            <TeamForm
              teamMembers={teamMembers}
              setTeamMembers={setTeamMembers}
              isUpdate={true} // true for UpdateCandidaturePage
              applicationUuid={uuid} // only for UpdateCandidaturePage
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
              <Button kind="ghost" size="sm" onClick={nextTab}>
                Próximo <ArrowRight20 />
              </Button>
            </div>
          </Tab>
          <Tab href="#" id="tab-3" label="Documentos">
            <DocumentForm
              documents={documents}
              setDocuments={setDocuments}
              isUpdate={true}
              applicationUuid={uuid}
            />
            <div className="tab-navigation">
              <Button kind="ghost" size="sm" onClick={previousTab}>
                <ArrowLeft20 /> Anterior
              </Button>
            </div>
          </Tab>
        </Tabs>
        <ButtonSet>
          {/* <SubmitButton className={"emprega-bg-green"} /> */}
          <CancelButton />
        </ButtonSet>
      </Form>
    </Card>
  );
};

export default UpdateCandidaturePage;
